<button mat-icon-button class="closer" [mat-dialog-close]="">
    <mat-icon mat-list-icon>X</mat-icon>
  </button>

<div class="search-multiple-dialog-wrapper">
    <div *ngIf="searchBy === 'pMNumber'" class="search-multiple-content">
        <h1>Search PM#s</h1>
        <h4>Add PM#s separated by commas</h4>
        <textarea (input)="searchInput = $event.target.value" [value]="searchInput"  placeholder="Add multiple PM#s"></textarea>
    </div>
    <div *ngIf="searchBy === 'notificationNumber'" class="search-multiple-content">
        <h1>Search by Notification #</h1>
        <h4>Add Notification #s separated by commas</h4>
        <textarea (input)="searchInput = $event.target.value" [value]="searchInput" placeholder="Add multiple Notifications #s"></textarea>
    </div>
    <div *ngIf="searchBy === 'jobAddress'" class="search-multiple-content">
        <h1>Search by Addresses</h1>
        <h4>Add Addresses separated by commas</h4>
        <textarea (input)="searchInput = $event.target.value" [value]="searchInput" placeholder="Add multiple Addresses"></textarea>
    </div>
    <div *ngIf="searchBy === 'invoiceNumber'" class="search-multiple-content">
        <h1>Search by Invoices #</h1>
        <h4>Add Invoices #s separated by commas</h4>
        <textarea (input)="searchInput = $event.target.value" [value]="searchInput" placeholder="Add multiple Invoices #s"></textarea>
    </div>

    <div class="dialog-actions">
        <button mat-raised-button color="accent" (click)="close()">Cancel</button>
        <button mat-raised-button color="primary" (click)="search()">Search</button>
    </div>
</div>